import { colors } from './colors';
import { typography } from './typography';
import { spacing } from './spacing';
import { radius } from './radius';
import { shadows } from './shadows';
import { buttons } from './buttons';
import { inputs } from './inputs';
import { animations } from './animations';
import { breakpoints } from './breakpoints';
import { transitions } from './transitions';
import { grid } from './grid';
import { zIndex } from './zIndex';

export const theme = {
  colors,
  typography,
  spacing,
  radius,
  shadows,
  buttons,
  inputs,
  animations,
  breakpoints,
  transitions,
  grid,
  zIndex,
};

export default theme;
